import { Record } from '@opengov/compose-app/immutable';
import { ReportConfigurationRecord } from '@opengov/reporting-types';
import { composeStateMachine } from '../../../module/module';
export var ChartState = Record({
  selectedCategory: null,
  selectedElements: [],
  selectedPoint: null,
  containerWidth: 1200,
  chartData: [],
  legendData: [],
  reportConfiguration: ReportConfigurationRecord(),
  chartContainerRect: {
    x: -1,
    y: -1,
    bottom: 0,
    top: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  },
  tooltip: {
    data: null,
    boundingClientRect: {
      x: -1,
      y: -1,
      bottom: 0,
      top: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    },
    targetElementRect: {
      x: -1,
      y: -1,
      bottom: 0,
      top: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    },
    domCoordinate: {
      x: 0,
      y: 0
    },
    show: 'hide',
    coordinate: null,
    targetSvgElement: null
  }
});
export var chartInitialState = ChartState();
export var chartState = composeStateMachine('COMPONENT-LIBRARY-CHART', chartInitialState, function (compose) {
  return {
    setContainerWidth: compose.action(function (state, payload) {
      return state.set('containerWidth', payload);
    }),
    setChartContainerRect: compose.action(function (state, payload) {
      return state.set('chartContainerRect', payload);
    }),
    setChartData: compose.action(function (state, payload) {
      return state.set('chartData', payload);
    }),
    setLegendData: compose.action(function (state, payload) {
      return state.set('legendData', payload);
    }),
    setChartAndLegendData: compose.action(function (state, payload) {
      return state.set('chartData', payload.chartData).set('legendData', payload.legendData).set('reportConfiguration', payload.reportConfiguration);
    }),
    setSelectedCategory: compose.action(function (state, payload) {
      return state.set('selectedCategory', payload);
    }),
    setSelectedPoint: compose.action(function (state, payload) {
      return state.set('selectedPoint', payload);
    }),
    setSelectedElements: compose.action(function (state, payload) {
      return state.set('selectedElements', payload);
    }),
    setTooltip: compose.action(function (state, payload) {
      return state.set('tooltip', payload);
    })
  };
});
var chartActions = chartState.actions,
    chartActionCreators = chartState.actionCreators,
    chartReducer = chartState.reducer,
    chartSelector = chartState.selector;
export { chartActions, chartActionCreators, chartReducer, chartSelector };